import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
   <>
    <section className="page-banner">
        <div className="page-banner-container">
          <h2>Privacy Policy</h2>
        </div>
      </section>
   
    <section className="privacy-section">

      <div className="privacy-container">

        {/* ================================
            HEADER
        ================================= */}

        <div className="privacy-header">

          <span className="privacy-label">
            Sai Shirdi Cab
          </span>

          <h1>
            Privacy Policy
          </h1>

          <p>
            At Sai Shirdi Cab, we respect your privacy and are committed
            to protecting your personal information. This Privacy Policy
            explains how we collect, use, and protect your information
            when you use our Shirdi cab booking and transportation
            services.
          </p>

        </div>


        {/* ================================
            CONTENT LAYOUT
        ================================= */}

        <div className="privacy-layout">


          {/* IMAGE */}

          <div className="privacy-image">

            <img
              src="/images/privacy.jpg"
              alt="Sai Shirdi Cab Service"
            />

            <div className="privacy-image-overlay">

              <span>
                Your Privacy Matters
              </span>

              <strong>
                Safe & Secure Shirdi Travel
              </strong>

            </div>

          </div>


          {/* CONTENT */}

          <div className="privacy-content">


            {/* INTRODUCTION */}

            <div className="privacy-text-block">

              <h3>
                Privacy Policy – Sai Shirdi Cab
              </h3>

              <p>
                At Sai Shirdi Cab, we respect your privacy and are
                committed to protecting your personal information.
                This Privacy Policy explains how we collect, use,
                store, and protect your information when you book
                or use our Shirdi cab services, Sai Baba Darshan
                trips, one-way taxi services, round-trip cabs, and
                other transportation services.
              </p>

            </div>


            {/* =================================
                INFORMATION WE COLLECT
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Information We Collect
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                1. Personal Information:
              </h3>

              <p>
                When you contact us or book our cab services, we may
                collect information such as your name, phone number,
                email address, pickup location, destination, travel
                date, passenger details, and other information required
                to arrange your Shirdi journey.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                2. Travel Booking Information:
              </h3>

              <p>
                We may collect details related to your journey including
                travel dates, number of passengers, vehicle requirements,
                pickup and drop locations, one-way or round-trip
                requirements, Sai Baba Darshan travel plans, and other
                booking-related information.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                3. Payment Information:
              </h3>

              <p>
                When you make a payment for our cab services, we may
                receive transaction-related information such as payment
                status, transaction reference, or other details required
                to confirm your booking. Payment information may be
                processed through third-party payment providers where
                applicable.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                4. Website Usage Information:
              </h3>

              <p>
                When you visit our website, we may collect technical
                information such as IP address, browser type, device
                information, operating system, and website usage data.
                This information helps us understand website usage and
                improve website performance and customer experience.
              </p>

            </div>


            {/* =================================
                HOW WE USE INFORMATION
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                How We Use Your Information
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                1. Cab Booking Management:
              </h3>

              <p>
                Your information helps us confirm your cab booking,
                arrange the required vehicle, coordinate pickup and
                drop-off, assign drivers, and provide smooth
                transportation for your Shirdi journey.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                2. Customer Support:
              </h3>

              <p>
                We may use your contact information to confirm bookings,
                communicate pickup details, provide travel updates,
                answer queries, handle booking changes, and provide
                customer assistance.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                3. Service Improvement:
              </h3>

              <p>
                Booking information, customer feedback, and website
                usage information may be used to improve our Shirdi
                cab services, vehicle options, booking process, and
                overall customer experience.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                4. Offers & Updates:
              </h3>

              <p>
                With your permission, we may send information about
                Shirdi cab services, special offers, discounts, new
                services, and travel updates. You can choose to stop
                receiving promotional communications at any time.
              </p>

            </div>


            {/* =================================
                INFORMATION SHARING
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Information Sharing
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                1. Drivers & Service Providers:
              </h3>

              <p>
                Necessary booking information may be shared with assigned
                drivers, vehicle operators, payment providers, or other
                service partners when required to complete your cab
                booking and provide transportation services.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                2. Legal Requirements:
              </h3>

              <p>
                We may disclose personal information when required by
                applicable law, government authorities, legal proceedings,
                or when necessary to protect the safety, rights, and
                legal interests of our customers or business.
              </p>

            </div>


            {/* =================================
                DATA SECURITY
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Data Security
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                Protection of Your Information:
              </h3>

              <p>
                Sai Shirdi Cab takes reasonable measures to protect
                customer information from unauthorized access, misuse,
                alteration, loss, or disclosure. However, no online
                transmission or electronic storage system can be
                guaranteed to be completely secure.
              </p>

            </div>


            {/* =================================
                YOUR RIGHTS
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Your Rights
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                Access & Correction:
              </h3>

              <p>
                Customers may contact us to request access to or
                correction of their personal information where
                applicable. You may also request deletion of personal
                information, subject to applicable legal or business
                requirements.
              </p>

            </div>


            <div className="privacy-text-block">

              <h3>
                Promotional Communications:
              </h3>

              <p>
                Customers can choose whether to receive promotional
                messages, offers, and service updates. You may request
                to stop receiving promotional communications at any time.
              </p>

            </div>


            {/* =================================
                COOKIES
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Cookies & Website Technologies
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                Website Cookies:
              </h3>

              <p>
                Our website may use cookies or similar technologies
                to remember preferences, understand website traffic,
                and improve website functionality and user experience.
                You may manage cookie preferences through your browser
                settings.
              </p>

            </div>


            {/* =================================
                POLICY UPDATES
            ================================= */}

            <div className="privacy-section-title">

              <h2>
                Policy Updates
              </h2>

            </div>


            <div className="privacy-text-block">

              <h3>
                Changes to This Privacy Policy:
              </h3>

              <p>
                This Privacy Policy may be updated from time to time
                to reflect changes in our services, website functionality,
                business practices, or applicable requirements. Updated
                information will be published on this page.
              </p>

            </div>


          </div>

        </div>


        {/* ================================
            IMPORTANT NOTE
        ================================= */}

        <div className="privacy-note">

          <div className="privacy-note-icon">
            ✓
          </div>

          <div>

            <h3>
              Your Privacy Matters
            </h3>

            <p>
              We value your trust and take reasonable steps to protect
              the information you provide while using Sai Shirdi Cab
              services. If you have any questions about this Privacy
              Policy or how your information is handled, please contact
              our support team.
            </p>

          </div>

        </div>


        {/* ================================
            CTA
        ================================= */}

        <div className="privacy-cta">

          <div>

            <span>
              Need a Shirdi Cab?
            </span>

            <h2>
              Travel Safely With Sai Shirdi Cab
            </h2>

          </div>

          <a href="/contact-us">
            Contact Us
          </a>

        </div>


      </div>

    </section>
   </>
  );
};

export default PrivacyPolicy;
